import { render, staticRenderFns } from "./UpdateGuide.vue?vue&type=template&id=2c37aa79"
import script from "./UpdateGuide.vue?vue&type=script&lang=js"
export * from "./UpdateGuide.vue?vue&type=script&lang=js"
import style0 from "./UpdateGuide.vue?vue&type=style&index=0&id=2c37aa79&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports